<ng-container *ngIf="step === 0">
  <app-camp-locations-list (showEditPreferredLocation)="handlePageContent($event)"></app-camp-locations-list>
  <div
    *ngIf="isFirstTime"
    style="margin-top: 5rem;"
  >
    <hr>
    <footer class="footer-action">
      <button
        class="btn btn-danger btn-block"
        (click)="onContinue()"
      >Continue</button>
    </footer>
  </div>
</ng-container>
<ng-container *ngIf="step === 1">
  <app-edit-preferred-location
    #editPreferredLocation
    (showCampLocationsList)="handlePageContent($event)"
    (showCampLocationSearchSelect)="handlePageContent($event)"
  ></app-edit-preferred-location>
</ng-container>
<ng-container *ngIf="step === 2">
  <app-search-preferred-location (showEditPreferredLocation)="handlePageContent($event)">
  </app-search-preferred-location>
</ng-container>